import React from 'react';
import {
  VStack,
  FormControl,
  FormLabel,
  Select,
  Textarea,
  useToast,
  Button,
  Box,
  Badge
} from '@chakra-ui/react';
import api from '../../../services/api';

const ProposalForm = ({ lead, onUpdate }) => {
  const toast = useToast();

  const handleSubmit = async (e) => {
    e.preventDefault();
    const formData = new FormData(e.target);
    
    try {
      const updatedLead = {
        ...lead,
        proposal: {
          status: formData.get('status'),
          details: formData.get('details')
        }
      };

      await api.put(`/api/leads/${lead.leadId}`, updatedLead);
      
      toast({
        title: 'Proposal updated',
        status: 'success',
        duration: 3000,
      });
      
      onUpdate?.(updatedLead);
    } catch (error) {
      console.error('Error updating proposal:', error);
      toast({
        title: 'Error updating proposal',
        description: error.response?.data?.message || error.message || 'Something went wrong',
        status: 'error',
        duration: 5000,
      });
    }
  };

  const getStatusColor = (status) => {
    switch (status) {
      case 'sent':
        return 'blue';
      case 'accepted':
        return 'green';
      case 'rejected':
        return 'red';
      default:
        return 'gray';
    }
  };

  return (
    <Box as="form" onSubmit={handleSubmit}>
      <VStack spacing={4} align="stretch">
        <FormControl>
          <FormLabel>Current Status</FormLabel>
          <Badge colorScheme={getStatusColor(lead.proposal?.status)} mb={2}>
            {lead.proposal?.status || 'pending'}
          </Badge>
        </FormControl>

        <FormControl>
          <FormLabel>Update Status</FormLabel>
          <Select 
            name="status"
            defaultValue={lead.proposal?.status || 'pending'}
          >
            <option value="pending">Pending</option>
            <option value="sent">Sent</option>
            <option value="accepted">Accepted</option>
            <option value="rejected">Rejected</option>
          </Select>
        </FormControl>

        <FormControl>
          <FormLabel>Proposal Details</FormLabel>
          <Textarea
            name="details"
            defaultValue={lead.proposal?.details || ''}
            placeholder="Enter proposal details..."
            rows={10}
            resize="vertical"
          />
        </FormControl>

        <Button type="submit" colorScheme="blue">
          Update Proposal
        </Button>
      </VStack>
    </Box>
  );
};

export default ProposalForm;
